'use client'
import * as React from 'react'

interface ThemeProps {
  brand: string
  children: React.ReactNode
}
/**
 * Theme - 主题配置
 *
 * @description 全局主题配置组件，用于设置品牌主题样式
 * @deprecated 已作废，不推荐使用，直接导入 design token 或者 覆盖css 变量 进行主题定制
 */
const Theme = ({ brand, children }: ThemeProps) => {
  React.useLayoutEffect(() => {
    document.querySelector('html')?.setAttribute('data-brand-theme', brand)
  }, [])
  return <>{children}</>
}

export default Theme
